import config from "@/common/config";

import ApiService from "./api.service";

export default {
  VERSION: config.api.versions.v2,

  /**
   * @param {string} packageGroup
   */
  updatePackageGroup(packageGroup) {
    return ApiService.post("user/settings", { packageGroup }, this.VERSION);
  },

  /**
   * @param {string} theme
   */
  updateTheme(theme) {
    return ApiService.post("user/settings", { theme }, this.VERSION);
  },

  /**
   * @param {string} font
   */
  updateFont(font) {
    return ApiService.post("user/settings", { font }, this.VERSION);
  },

  /**
   * @param {boolean} expandedDefault
   */
  updateOrdbogenArticleTranslationsExpandedDefault(expandedDefault) {
    return ApiService.post(
      "user/settings",
      { ordbogenArticleTranslationsExpandedDefault: expandedDefault ? "1" : "0" },
      this.VERSION
    );
  },

  /**
   * @param {boolean} expandedDefault
   */
  updateGyldendalArticleTranslationsExpandedDefault(expandedDefault) {
    return ApiService.post(
      "user/settings",
      { gyldendalArticleTranslationsExpandedDefault: expandedDefault ? "1" : "0" },
      this.VERSION
    );
  },

  /**
   * @param {string} wordclassLevel
   */
  updateOrdbogenWordclassLevel(wordclassLevel) {
    return ApiService.post(
      "user/settings",
      { ordbogenWordclassLevel: wordclassLevel },
      this.VERSION
    );
  },

  /**
   * @param {boolean} allowHelpTools
   */
  setAllowHelpTools(allowHelpTools) {
    return ApiService.post(
      "user/settings",
      { allowHelpTools: allowHelpTools ? "1" : "0" },
      this.VERSION
    );
  },

  onboardingShown() {
    return ApiService.post("user/settings", { onboardingShown: "1" }, this.VERSION);
  }
};
